import { IIdTextId } from '../shared/fi-shared-interfaces';
import { FiOnboardingCategoryType, FiOnboardingStatusType } from './fi-onboarding-enums';
import { ProgressStatusConfigType } from '@fi-shared/fi-progress-badge/fi-progress-badge.d';

export const FiOnboardingCategories: IIdTextId[] = [
    {
        id: FiOnboardingCategoryType.Independent,
        textId: 'onboarding.independent',
    },
    {
        id: FiOnboardingCategoryType.SyncReady,
        textId: 'onboarding.sync_ready',
    },
    {
        id: FiOnboardingCategoryType.Synchronized,
        textId: 'onboarding.synchronized',
    },
];

export const FiOnboardingStatuses: IIdTextId[] = [
    {
        id: FiOnboardingStatusType.NotStarted,
        textId: 'checklist.not_started',
    },
    {
        id: FiOnboardingStatusType.InProgress,
        textId: 'taskv2.in_progress',
    },
    {
        id: FiOnboardingStatusType.Completed,
        textId: 'common.completed',
    },
];

export const FiOnboardingStatusesConfig: ProgressStatusConfigType<FiOnboardingStatusType> = {
    [FiOnboardingStatusType.NotAvailable]: {
        textId: undefined,
        statusClass: undefined,
    },
    [FiOnboardingStatusType.NotStarted]: {
        textId: 'checklist.not_started',
        statusClass: 'fi-progress-badge--not-started',
    },
    [FiOnboardingStatusType.InProgress]: {
        textId: 'taskv2.in_progress',
        statusClass: 'fi-progress-badge--in-progress',
    },
    [FiOnboardingStatusType.Completed]: {
        textId: 'common.completed',
        statusClass: 'fi-progress-badge--completed',
    },
};
